<template>
    <div class="companies-wrapper">
        <div v-html="html"></div>

        <button
            v-if="!end"
            :disabled="loading"
            @click="paginate()"
            class="btn w-100 border2 br100 border-neutral-300 border-neutral-400-hover body-medium font-weight-bold mt40 text-neutral-700"
        >
            <span v-if="!loading">Carregar mais empresas</span>
            <span v-else>
                <i class="bx bx-loader bx-spin"></i>
            </span>
        </button>
    </div>
</template>

<script>
import axios from "axios"

export default {
    name: "ShowCompaniesWrapper",
    props: {
        currentPage: {
            type: String,
            required: false,
            default: "1",
        },
        seed: {
            type: String,
            required: false,
        },
        query: {
            type: Object,
            required: true,
        },
        // Última página informada pelo servidor (SSR). Sem ela, o fim só é
        // descoberto pelo header X-Last-Page da API ou por resposta vazia.
        lastPage: {
            type: Number,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            end: this.lastPage !== null && Number(this.currentPage) >= this.lastPage,
            loading: false,
            page: this.currentPage,
            html: "",
        }
    },
    watch: {
        currentPage() {
            this.page = this.currentPage
        },
    },
    methods: {
        paginate() {
            this.page++
            this.loadCompanies()
        },
        loadCompanies() {
            if (this.end) return

            this.loading = true
            axios
                .get(window.apis.empresas, {
                    params: {
                        page: this.page,
                        seed: this.seed,
                        ...this.query,
                        includes: "id",
                        segmento: window.parameters.segmento || null
                    },
                })
                .then((response) => {
                    if (!response.data) {
                        this.end = true
                        return
                    }

                    this.html += response.data

                    const lastPage = Number(response.headers["x-last-page"])
                    if (lastPage && Number(this.page) >= lastPage) {
                        this.end = true
                    }
                })
                .finally(() => (this.loading = false))
        },
    },
}
</script>
